export default {
  total_responses: 'Respuestas',
  top_two_box: 'Satisfacción (top 2)',
  average_score: 'Puntaje promedio',
  keep_reading: '¿Seguir leyendo?',
  keep_reading_yes: 'Sí',
  keep_reading_maybe: 'Tal vez',
  keep_reading_no: 'No',
  distribution_title: 'Distribución del Smileyómetro',
  breakdown_title: 'Resultados por segmento',
  by_grade: 'Grado',
  by_school: 'Escuela',
  by_country: 'País',
  col_segment: 'Segmento',
  col_responses: 'Respuestas',
  col_top_two_box: 'Satisfacción (top 2)',
  col_average: 'Promedio',
  scores: {
    1: 'Muy insatisfecho',
    2: 'Insatisfecho',
    3: 'Neutral',
    4: 'Satisfecho',
    5: 'Muy satisfecho',
  },
};
